module.exports = __webpack_public_path__ + "static/media/lohono-story.88935d72.webp";